import type { SuggestionsGroup } from 'client-site-chrome-ui/components/molecules/SearchSuggestions/types';

export const getSuggestionByGlobalIndex = (groups: SuggestionsGroup[], globalIndex: number) =>
  groups
    .map((group) => group.suggestions)
    .flat()
    .find((item) => item.globalIndex === globalIndex);
